import { render, staticRenderFns } from "./PasswordResetTab.vue?vue&type=template&id=75c93c38&scoped=true&"
import script from "./PasswordResetTab.vue?vue&type=script&lang=js&"
export * from "./PasswordResetTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c93c38",
  null
  
)

export default component.exports